var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#919EAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1176 15.1298L26.8762 12.7908C25.838 12.4031 24.137 12.4031 23.0988 12.7908L16.8574 15.1298C15.419 15.6676 14.2433 17.3687 14.2433 18.8946V28.1879C14.2433 29.6639 15.2189 31.6026 16.4071 32.4906L21.7855 36.5056C23.5491 37.8315 26.4509 37.8315 28.2145 36.5056L33.5929 32.4906C34.7811 31.6026 35.7567 29.6639 35.7567 28.1879V18.8946C35.7317 17.3687 34.556 15.6676 33.1176 15.1298ZM24.8999 18.7821C26.3759 18.7821 27.5766 19.9828 27.5766 21.4587C27.5766 22.9096 26.4384 24.0729 25 24.1229H24.975H24.95C24.925 24.1229 24.8999 24.1229 24.8749 24.1229C23.374 24.0729 22.2483 22.9096 22.2483 21.4587C22.2358 19.9828 23.4365 18.7821 24.8999 18.7821ZM27.7267 30.4518C26.9637 30.9522 25.9756 31.2148 24.9875 31.2148C23.9994 31.2148 22.9988 30.9647 22.2483 30.4518C21.5353 29.9765 21.1476 29.3261 21.1351 28.6132C21.1351 27.9128 21.5353 27.2373 22.2483 26.762C23.7617 25.7614 26.2258 25.7614 27.7392 26.762C28.4522 27.2373 28.8524 27.8877 28.8524 28.6007C28.8399 29.3011 28.4397 29.9765 27.7267 30.4518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacy);
export default __webpack_public_path__ + "static/media/icon_privacy.28c6af719a850d7228af8a9a618cceba.svg";
export { ForwardRef as ReactComponent };